import { render, staticRenderFns } from "./MarketFourth.vue?vue&type=template&id=8933b864&scoped=true"
import script from "./MarketFourth.vue?vue&type=script&lang=js"
export * from "./MarketFourth.vue?vue&type=script&lang=js"
import style0 from "./MarketFourth.vue?vue&type=style&index=0&id=8933b864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8933b864",
  null
  
)

export default component.exports